import {Optional} from 'typescript-optional';
import {BaseAuthCriteriaModel} from "./base-auth-criteria.model";

export class AppLoginPrincipalQueryCriteriaClass extends BaseAuthCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  subject_guid?: Optional<string> = Optional.empty();
  principal_type?: Optional<string> = Optional.empty();
  principal_id?: Optional<string> = Optional.empty();
  principal_value?: Optional<string> = Optional.empty();
  credential?: Optional<string> = Optional.empty();
  valid_date_start?: Optional<string> = Optional.empty();
  valid_date_end?: Optional<string> = Optional.empty();
  revision?: Optional<string> = Optional.empty();
  vrsn?: Optional<string> = Optional.empty();
  status?: Optional<string> = Optional.empty();

  guids?: Optional<string> = Optional.empty();
  subject_guids?: Optional<string> = Optional.empty();
}

export class AppLoginPrincipalCriteriaModelQuery {
  query = '';

  constructor(appLoginPrincipalCriteriaModel: AppLoginPrincipalQueryCriteriaClass) {

    if (!appLoginPrincipalCriteriaModel) {
      return;
    }

    this.query += appLoginPrincipalCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.subject_guid.filter(x => x !== '').map(x => '&subject_guid=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.principal_type.filter(x => x !== '').map(x => '&principal_type=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.principal_id.filter(x => x !== '').map(x => '&principal_id=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.principal_value.filter(x => x !== '').map(x => '&principal_value=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.credential.filter(x => x !== '').map(x => '&credential=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.valid_date_start.filter(x => x !== '').map(x => '&valid_date_start=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.valid_date_end.filter(x => x !== '').map(x => '&valid_date_end=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.revision.filter(x => x !== '').map(x => '&revision=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.vrsn.filter(x => x !== '').map(x => '&vrsn=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.status.filter(x => x !== '').map(x => '&status=' + x).orElse('');

    this.query += appLoginPrincipalCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');
    this.query += appLoginPrincipalCriteriaModel.subject_guids.filter(x => x !== '').map(x => '&subject_guids=' + x).orElse('');


    this.query += '&orderBy=' + appLoginPrincipalCriteriaModel.orderBy;
    this.query += '&order=' + appLoginPrincipalCriteriaModel.order;
    this.query += '&offset=' + appLoginPrincipalCriteriaModel.offset + '&limit=' + appLoginPrincipalCriteriaModel.limit;
  }
}
